import { api } from "..";

export const cancelCoupon = async (couponId: string) => {
  const res = await api.client.post(`/coupon-new/${couponId}/cancel`);
  return res.data;
};
